import clsx from "clsx";
import React from "react";
import { useNavigation } from "../../../hooks";
import Card from "../../ui/Card";
import Icon from "../../ui/Icon";

const SettingsScreen: React.FC = () => {
  const {
    navigateToHome,
    navigateToMyDataManagement,
    navigateToMarketingConsent,
    navigateToAccountDeletion,
  } = useNavigation();

  const settingsItems = [
    {
      id: "mydata-management",
      title: "마이데이터 관리",
      icon: "document",
      onClick: navigateToMyDataManagement,
    },
    {
      id: "marketing-consent",
      title: "마케팅 정보 수신 동의",
      icon: "send",
      onClick: navigateToMarketingConsent,
    },
    {
      id: "account-deletion",
      title: "회원 탈퇴",
      icon: "trash",
      onClick: navigateToAccountDeletion,
      isDestructive: true,
    },
  ];

  return (
    <div className="h-screen-dvh bg-white flex flex-col">
      {/* 상단 헤더 */}
      <header className="bg-white px-4 py-3 flex items-center">
        <button
          onClick={navigateToHome}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <Icon name="chevron-left" className="text-text-secondary" />
        </button>      </header>

      {/* 메인 콘텐츠 */}
      <main className="flex-1 p-4">
        <div className="space-y-4">
          {settingsItems.map((item) => (
            <Card
              key={item.id}
              className="cursor-pointer hover:bg-gray-50 transition-colors"
            >
              <button
                onClick={item.onClick}
                className="w-full text-left flex items-center space-x-4"
              >
                <div
                  className={clsx(
                    "flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center",
                    item.isDestructive ? "bg-red-100" : "bg-blue-100"
                  )}
                >
                  <Icon
                    name={item.icon}
                    className={item.isDestructive ? "text-red-600" : "text-blue-600"}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3
                    className={clsx(
                      "font-medium",
                      item.isDestructive ? "text-red-600" : "text-text-primary"
                    )}
                  >
                    {item.title}
                  </h3>
                </div>
                <div className="flex-shrink-0">
                  <Icon name="chevron-right" className="text-text-tertiary" />
                </div>
              </button>
            </Card>
          ))}
        </div>

        {/* 하단 버전 정보 */}
        <div className="mt-8 text-center">
          <p className="text-s text-text-tertiary">버전 1.0.0</p>
        </div>
      </main>
    </div>
  );
};

export default SettingsScreen;
